// Creative Vibes — Currency selector (display-only; checkout is always in AED)
(function () {
  var BASE = 'AED', KEY = 'cv_currency', RKEY = 'cv_rates_v1';
  var CURR = {
    AED: { s: 'AED', dp: 2, pre: false }, USD: { s: '$', dp: 2, pre: true },
    EUR: { s: '€', dp: 2, pre: true }, GBP: { s: '£', dp: 2, pre: true },
    CAD: { s: 'CA$', dp: 2, pre: true }, AUD: { s: 'A$', dp: 2, pre: true },
    SAR: { s: 'SAR', dp: 2, pre: false }, QAR: { s: 'QAR', dp: 2, pre: false },
    KWD: { s: 'KWD', dp: 3, pre: false }, BHD: { s: 'BHD', dp: 3, pre: false },
    OMR: { s: 'OMR', dp: 3, pre: false }, EGP: { s: 'EGP', dp: 2, pre: false },
    SEK: { s: 'kr', dp: 2, pre: false }, NOK: { s: 'kr', dp: 2, pre: false },
    DKK: { s: 'kr', dp: 2, pre: false }, NZD: { s: 'NZ$', dp: 2, pre: true }
  };
  var ORDER = ['AED', 'USD', 'EUR', 'GBP', 'CAD', 'AUD', 'SAR', 'QAR', 'KWD', 'BHD', 'OMR', 'EGP', 'SEK', 'NOK', 'DKK', 'NZD'];
  var FALLBACK = { AED: 1, USD: 0.272, EUR: 0.251, GBP: 0.214, CAD: 0.372, AUD: 0.416, SAR: 1.021, QAR: 0.991, KWD: 0.0835, BHD: 0.1026, OMR: 0.1048, EGP: 13.5, SEK: 2.9, NOK: 2.95, DKK: 1.87, NZD: 0.454 };
  var rates = FALLBACK, WRITING = false;

  function sel() { try { return localStorage.getItem(KEY) || BASE; } catch (e) { return BASE; } }
  function setSel(c) { try { localStorage.setItem(KEY, c); } catch (e) { } }

  function loadRates() {
    try {
      var c = JSON.parse(localStorage.getItem(RKEY) || 'null');
      if (c && c.t && (Date.now() - c.t) < 43200000 && c.r) { rates = c.r; return Promise.resolve(); }
    } catch (e) { }
    return fetch('https://open.er-api.com/v6/latest/AED')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.rates) {
          var r = {}; ORDER.forEach(function (k) { if (d.rates[k] != null) r[k] = d.rates[k]; });
          r.AED = 1; rates = Object.assign({}, FALLBACK, r);
          try { localStorage.setItem(RKEY, JSON.stringify({ t: Date.now(), r: rates })); } catch (e) { }
        }
      })
      .catch(function () { rates = FALLBACK; });
  }

  function parseNum(t) {
    if (t == null) return null;
    var m = String(t).replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }
  function money(aed, code) {
    var c = CURR[code] || CURR.AED;
    var v = aed * (rates[code] || 1);
    var n = v.toLocaleString('en-US', { minimumFractionDigits: c.dp, maximumFractionDigits: c.dp });
    return c.pre ? (c.s + n) : (n + ' ' + c.s);
  }

  // Generic price nodes (text holds the whole price)
  var SELECTORS = '.cv-pc-price,.cv-ni-price,.cv-rc-price,.cv-pill-price,#cvStickyPrice,.cv-ci-price,#cvCartTotal';

  function renderNode(el, code) {
    var cur = el.textContent;
    if (cur !== el.getAttribute('data-cv-txt')) {          // external write or first sight -> this is native AED
      el.setAttribute('data-cv-orig', cur);
      var b = parseNum(cur);
      if (b != null) el.setAttribute('data-cv-aed', String(b));
      if (/from/i.test(cur)) el.setAttribute('data-cv-from', '1');
    }
    var base = parseFloat(el.getAttribute('data-cv-aed'));
    if (isNaN(base)) return;
    var out = (code === BASE) ? el.getAttribute('data-cv-orig')
      : ((el.getAttribute('data-cv-from') === '1' ? 'From ' : '') + money(base, code));
    if (out === cur && el.getAttribute('data-cv-cur') === code) return;
    el.textContent = out;
    el.setAttribute('data-cv-txt', out);
    el.setAttribute('data-cv-cur', code);
  }

  // Product page main price: number in #cvPriceVal, "AED" label in .cv-price-cur
  function renderMain(code) {
    var pv = document.getElementById('cvPriceVal');
    if (!pv) return;
    var lab = document.querySelector('.cv-price-cur');
    var cur = pv.textContent;
    if (cur !== pv.getAttribute('data-cv-txt')) {
      pv.setAttribute('data-cv-orig', cur);
      var b = parseNum(cur);
      if (b != null) pv.setAttribute('data-cv-aed', String(b));
    }
    var base = parseFloat(pv.getAttribute('data-cv-aed'));
    if (isNaN(base)) return;
    var out;
    if (code === BASE) { out = pv.getAttribute('data-cv-orig'); if (lab) lab.style.display = ''; }
    else { out = money(base, code); if (lab) lab.style.display = 'none'; }
    if (out === cur && pv.getAttribute('data-cv-cur') === code) return;
    pv.textContent = out;
    pv.setAttribute('data-cv-txt', out);
    pv.setAttribute('data-cv-cur', code);
  }

  function note(id, host, where, show, code) {
    if (!host) return;
    var n = document.getElementById(id);
    if (!n) { n = document.createElement('div'); n.id = id; n.className = 'cv-cur-note'; where(host, n); }
    n.textContent = 'Shown in ' + code + ' · charged in AED at checkout';
    n.style.display = show ? 'block' : 'none';
  }

  function convertAll() {
    WRITING = true;
    var code = sel();
    try {
      var nodes = document.querySelectorAll(SELECTORS);
      for (var i = 0; i < nodes.length; i++) renderNode(nodes[i], code);
      renderMain(code);
      var show = code !== BASE;
      note('cvCurNoteCart', document.querySelector('.cv-cart-footer'), function (h, n) { h.insertBefore(n, h.firstChild); }, show, code);
      note('cvCurNoteProd', document.getElementById('cvProdPrice'), function (h, n) { h.parentNode.insertBefore(n, h.nextSibling); }, show, code);
    } catch (e) { }
    setTimeout(function () { WRITING = false; }, 0);
  }

  function injectCSS() {
    if (document.getElementById('cvCurCSS')) return;
    var st = document.createElement('style'); st.id = 'cvCurCSS';
    st.textContent = ".cv-cur-select{font-family:var(--font-body,'Jost',sans-serif);font-size:12px;font-weight:500;color:#5C2D82;background:#fff;border:1px solid rgba(140,90,180,.3);border-radius:5px;padding:5px 6px;margin-right:8px;cursor:pointer;outline:none;transition:border-color .2s;}.cv-cur-select:focus{border-color:#8B4DB3;}.cv-cur-note{font-family:var(--font-body,'Jost',sans-serif);font-size:10.5px;letter-spacing:.2px;color:#8B6AAA;margin:8px 0 2px;text-align:center;}";
    document.head.appendChild(st);
  }

  function buildUI() {
    var right = document.querySelector('.cv-nav-right');
    if (!right || document.getElementById('cvCurrency')) return;
    var s = document.createElement('select');
    s.id = 'cvCurrency'; s.className = 'cv-cur-select'; s.setAttribute('aria-label', 'Currency');
    ORDER.forEach(function (c) { var o = document.createElement('option'); o.value = c; o.textContent = c; s.appendChild(o); });
    s.value = sel();
    s.addEventListener('change', function () { setSel(s.value); convertAll(); });
    right.insertBefore(s, right.firstChild);
  }

  function init() {
    injectCSS(); buildUI(); convertAll();
    loadRates().then(convertAll);
    var t, obs = new MutationObserver(function () { if (WRITING) return; clearTimeout(t); t = setTimeout(convertAll, 120); });
    obs.observe(document.body, { subtree: true, childList: true, characterData: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.cv-variant-pill,.cv-cart-btn,.cv-ci-remove,#cvAddToCart')) setTimeout(convertAll, 60);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
